import styled from 'styled-components';
import { rem } from 'polished';
import { ColorSelectStyled } from '../../ColorSelectStyled';

export const ColorSelectStyledOVGB = styled(ColorSelectStyled)`
    .name {
        font-size: ${rem(16)};
    }

    .price {
        font-size: ${({ theme }) => theme.fontSizes.h5};
    }
`;
